var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Box, Button, Card, CardContent, CircularProgress, Typography, } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAcceptInvitationByToken, usePreviewInvitationByToken, } from "../api/InvitationApiProvider";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
export var JoinTeamByInvitation = function () {
    var token = useParams().token;
    var navigate = useNavigate();
    var _a = __read(React.useState(""), 2), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = usePreviewInvitationByToken({ token: token }), invitation = _b.data, isPreviewLoading = _b.isLoading, isPreviewError = _b.isError;
    var acceptMutation = useAcceptInvitationByToken({
        onMutate: function () { },
        onSuccess: function (response) {
            var _a;
            var teamId = (_a = response.data) === null || _a === void 0 ? void 0 : _a.team;
            navigate(teamId ? "/teams/".concat(teamId) : "/teams");
        },
        onError: function (error) {
            var _a, _b;
            var messages = Object.values((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {})
                .flat()
                .join(" ");
            if (messages.includes("already a member") && (invitation === null || invitation === void 0 ? void 0 : invitation.team)) {
                navigate("/teams/".concat(invitation.team));
            }
            else {
                setErrorMessage(messages ||
                    "Failed to accept invitation. The link may be invalid or expired.");
            }
        },
    });
    var declineMutation = useAcceptInvitationByToken({
        onMutate: function () { },
        onSuccess: function () { return navigate("/invitations"); },
        onError: function () { return setErrorMessage("Failed to decline invitation."); },
    });
    if (!token) {
        return (_jsx(Box, { sx: { textAlign: "center", mt: 8 }, children: _jsx(Typography, { variant: "h5", color: "error", children: "Invalid invitation link" }) }));
    }
    if (isPreviewLoading) {
        return _jsx(Loading, {});
    }
    var isProcessing = acceptMutation.isLoading || declineMutation.isLoading;
    return (_jsxs(React.Fragment, { children: [_jsx(Box, { sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "60vh",
                }, children: _jsx(Card, { variant: "outlined", sx: { maxWidth: 450, width: "100%", p: 2 }, children: _jsx(CardContent, { sx: { textAlign: "center" }, children: isProcessing ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { sx: { mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: acceptMutation.isLoading
                                        ? "Accepting invitation..."
                                        : "Declining invitation..." })] })) : acceptMutation.isError || declineMutation.isError ? (_jsxs(_Fragment, { children: [_jsx(MailOutlineIcon, { color: "error", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Something went wrong" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: errorMessage || "The link may be invalid or expired." })] })) : isPreviewError || !invitation ? (_jsxs(_Fragment, { children: [_jsx(MailOutlineIcon, { color: "error", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "Invalid invitation" }), _jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: "This invitation link is invalid or has already been used." })] })) : (_jsxs(_Fragment, { children: [_jsx(MailOutlineIcon, { color: "primary", sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { variant: "h5", gutterBottom: true, children: "You've been invited to join" }), _jsx(Typography, { variant: "h4", sx: { fontWeight: 700, mb: 1 }, children: invitation.teamName }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 1 }, children: ["Invited by ", invitation.inviterFirstName, " ", invitation.inviterLastName] }), invitation.message && (_jsxs(Typography, { variant: "body1", sx: {
                                        mb: 2,
                                        fontStyle: "italic",
                                        p: 2,
                                        bgcolor: "grey.50",
                                        borderRadius: 1,
                                    }, children: ["\u201C", invitation.message, "\u201D"] })), invitation.mergePlayer && (_jsx(Typography, { variant: "body2", color: "info.main", sx: { mb: 2 }, children: "Your stats will be merged with an existing offline player on this team." })), _jsxs(Box, { sx: { display: "flex", gap: 2, justifyContent: "center" }, children: [_jsx(Button, { variant: "contained", color: "success", size: "large", startIcon: _jsx(CheckCircleIcon, {}), onClick: function () {
                                                return acceptMutation.mutate({ token: token, status: "ACCEPTED" });
                                            }, children: "Accept" }), _jsx(Button, { variant: "outlined", color: "error", size: "large", startIcon: _jsx(DoNotDisturbIcon, {}), onClick: function () {
                                                return declineMutation.mutate({ token: token, status: "DECLINED" });
                                            }, children: "Decline" })] })] })) }) }) }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
